import { Event } from "../models/event";
import { EventViewModel } from "../models/eventViewModel";

// TODO: Replace with proper mapped fields once BE provides cleaned structure
export const mapEventEntityToViewModel = (event: Event): EventViewModel => {
  return {
    ...event,
    timestamp: event.ddbRecord.GSIPK5?.split("#E#")[1] ?? "",
    modelId: event.ddbRecord.GSIPK2?.split("#E#")[1] ?? "",
    facilityId: event.ddbRecord.GSIPK4?.split("#L#")[1] ?? "",
    mitigatedRisk: event.ddbRecord.mitigatedRisk?.split(";") ?? [],
    location: event.ddbRecord.GSIPK4,
  };
};
